import React, { Component } from "react";

import { Metric } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class LeeMetrics extends Component {
  render() {
    const { data } = this.props.data;

    return (
      <div className="row">
        {data.paying_subscriptions && (
          <div className="mb-4 col ">
            <Heading size={6} className={"mb-1"}>
              Total Paying Subscribers
            </Heading>
            <Metric {...data.paying_subscriptions} size={"lg"} format={"0"} />
          </div>
        )}

        {data.apple && !data.apple.cancellations && (
          <div className="mb-4 col ">
            <Heading size={6} className={"mb-1"}>
              Apple
            </Heading>
            <Metric {...data.apple} size={"lg"} format={"0"} />
          </div>
        )}

        {data.google && !data.google.cancellations && (
          <div className="mb-4 col ">
            <Heading size={6} className={"mb-1"}>
              Google Play
            </Heading>
            <Metric {...data.google} size={"lg"} format={"0"} />
          </div>
        )}

        {data.installs && (
          <div className="mb-4 col">
            <Heading size={6} className={"mb-1"}>
              Installs
            </Heading>
            <Metric {...data.installs} size={"lg"} format={"0"} />
          </div>
        )}

        {data.uninstalls && (
          <div className="mb-4 col">
            <Heading size={6} className={"mb-1"}>
              Uninstalls
            </Heading>
            <Metric {...data.uninstalls} size={"lg"} format={"0"} />
          </div>
        )}

        {data.activations && (
          <div className="mb-4 col">
            <Heading size={6} className={"mb-1"}>
              Activations
            </Heading>
            <Metric {...data.activations} size={"lg"} />
          </div>
        )}

        {data.cancellations && (
          <div className="mb-4 col">
            <Heading size={6} className={"mb-1"}>
              Cancellations
            </Heading>
            <Metric {...data.cancellations} size="lg" />

            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Google</h6>
              <Metric value={data.Google.value} size={"xs"} format={"0"} />
              &nbsp;
              <Metric value={data.Google.pct} size={"xs"} format={"%"} />
            </div>
            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Apple</h6>
              <Metric value={data.Apple.value} size={"xs"} format={"0"} />
              &nbsp;
              <Metric value={data.Apple.pct} size={"xs"} format={"%"} />
            </div>
          </div>
        )}

        {data.conversion_rate && (
          <div className="mb-4 col-6">
            <Heading size={6} className={"mb-1"}>
              Conversion Rate
            </Heading>
            <Metric
              {...data.conversion_rate}
              size={"lg"}
              format="%"
              type="percentage"
            />
          </div>
        )}

        {data.renewal_rate && (
          <div className="mb-4 col-6">
            <Heading size={6} className={"mb-1"}>
              Renewal Rate
            </Heading>
            <Metric
              {...data.renewal_rate}
              size={"lg"}
              format="%"
              type="percentage"
            />
          </div>
        )}

        {data.total && (
          <div className="mb-4 col">
            <Heading size={6} className={"mb-1"}>
              Total
            </Heading>
            <Metric
              {...{
                ...data.total,
                value: data.total.value,
              }}
              format="0.00%"
              size="lg"
            />
            <Metric
              value={`${data.total.cancellations}/${data.total.subscriptions}`}
              showPureValue={true}
              size="sm"
            />
          </div>
        )}

        {data.apple?.cancellations && (
          <div className="mb-4 col">
            <Heading size={6} className={"mb-1"}>
              Apple
            </Heading>
            <Metric
              {...{
                ...data.apple,
                value: data.apple.value,
              }}
              format="0.00%"
              size="lg"
            />
            <Metric
              value={`${data.apple.cancellations}/${data.apple.subscriptions}`}
              showPureValue={true}
              size="sm"
            />
          </div>
        )}

        {data.google?.cancellations && (
          <div className="mb-4 col">
            <Heading size={6} className={"mb-1"}>
              Google
            </Heading>
            <Metric
              {...{
                ...data.google,
                value: data.google.value,
              }}
              format="0.00%"
              size="lg"
            />
            <Metric
              value={`${data.google.cancellations}/${data.google.subscriptions}`}
              showPureValue={true}
              size="sm"
            />
          </div>
        )}
      </div>
    );
  }
}

export default LeeMetrics;
